(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/suspensionhistory-list.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/suspensionhistory-list.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.SuspensionHistoryList = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: svs.spelpaus.views.SuspensionHistoryItem,
    behaviors: {
      ServerSideRendering: {}
    }
  });
})(Backbone, _, svs);

 })(window);